import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import './index.css';
import App from './App';
import './SavelUI.css';
import { installTextSuggestions } from './utils/textSuggestions';

// Android WebView строже браузера трактует autocomplete="off" и может
// отключить строку предиктивного ввода целиком. Подготавливаем все обычные
// текстовые поля сразу при появлении в DOM, до того как пользователь их откроет.
installTextSuggestions(document);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// В нативном Android-приложении интерфейс всегда должен браться из текущего APK.
// Старый service worker или Cache Storage могут пережить обновление приложения
// и показать предыдущую версию интерфейса.
if (Capacitor.isNativePlatform()) {
  window.addEventListener('load', async () => {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations().catch(() => []);
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
    if ('caches' in window) {
      const cacheNames = await window.caches.keys().catch(() => []);
      await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
    }
  });
} else if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/sw.js`).catch(() => {});
  });
}
